import { render, staticRenderFns } from "./AggregateSurveys.vue?vue&type=template&id=cd264b2c&scoped=true&"
import script from "./AggregateSurveys.vue?vue&type=script&lang=js&"
export * from "./AggregateSurveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd264b2c",
  null
  
)

export default component.exports